module.exports = __webpack_public_path__ + "img/hash.0f8b2292.svg";